export default __webpack_public_path__ + "d9581779d1abac7499bdf97f38db5f8b.svg";